import { createFileRoute } from '@tanstack/react-router';
import { createRouteConfig } from '../utils/routeGuard';
import { Header } from '@/components/public/Header';
import { BackLink } from '@/components/public/BackLink';
import { Hero } from '@/components/public/features/Hero';
import { FeatureNavigationTiles } from '@/components/public/features/FeatureNavigationTiles';
import { SuggestedJobs } from '@/components/public/features/SuggestedJobs';
import { ApplicationImprovement } from '@/components/public/features/ApplicationImprovement';
import { ApplicationTracking } from '@/components/public/features/ApplicationTracking';
import { Mobile } from '@/components/public/features/Mobile';
import { PricingTeaser } from '@/components/public/PricingTeaser';
import { FinalCTA } from '@/components/public/FinalCTA';
import { Footer } from '@/components/Footer';

export const Route = createFileRoute('/features')({
  component: Features,
  ...createRouteConfig({
    isPublic: true,
  }),
});

function Features() {
  return (
    <div className='min-h-screen bg-white text-slate-900'>
      <Header />
      <BackLink />
      <Hero />
      <FeatureNavigationTiles />
      <SuggestedJobs />
      <ApplicationImprovement />
      <ApplicationTracking />
      <Mobile />
      <PricingTeaser />
      <FinalCTA />
      <Footer />
    </div>
  );
}
